import { getListViewTypeWithoutPreview } from '../../../../utils/listViewType'

// A closed panel is a per-visit state: the view type the user chose stays put.
export function getLayoutListViewType({ isPreviewClosed, listViewType }) {
  return isPreviewClosed
    ? getListViewTypeWithoutPreview(listViewType)
    : listViewType
}
